import { lazy } from 'react';
import { AuthGuard, DashboardLayout } from '@nsd/fe';
import UsersIcon from 'react-feather/dist/icons/user';
import GlobeIcon from 'react-feather/dist/icons/globe';
import PackageIcon from 'react-feather/dist/icons/package';
import RolesIcon from 'react-feather/dist/icons/tag';
import SuitesIcon from 'react-feather/dist/icons/grid';
import { HeadsetMic as CallCenterIcon } from '@material-ui/icons';

const appIcon = 'https://nsdstaticasset.blob.core.windows.net/assets/Qore_Brand_Icons/adminQoreAppIcon.png';
const MODULE = {
  USERS: 'users-7293807b-815f-4fde-8f32-8a7dbfede045',
  COMPANIES: 'companies-8cb0bd03-9872-4625-8626-3d7822841613',
  ROLES: 'roles-a96c187c-5c95-4b86-9624-033970d3aae2',
  PACKAGES: 'packages-213196f1-8879-48f7-88d6-76b6dc24c494',
  SUITES: 'suites-d7b51bd8-1113-4c7d-b044-ea5e012b9b6b',
  CALL_CENTERS: 'callCenters-d73a22e1-bd27-4e36-9674-35d08ae0ed0d',
};

/*
  Note: customerPortal-9b2c764c-2832-4519-800a-4107ff4fdd8e suite doesn't have any apps
  (As of 2/21/2022) within it so none will show up on the app menu in the topBar unless added
 */
const appConfig = {
  appId: 'admin-cf196b57-0774-4a2c-bff0-04a4f44d7f0d',
  appName: 'Admin',
  priority: 1,
  path: 'admin',
  icon: appIcon,
  guard: AuthGuard,
  layout: DashboardLayout,
  routes: [
    {
      exact: true,
      path: 'companies',
      view: lazy(() => import('src/views/AdminCompaniesView/index')),
      module: MODULE.COMPANIES,
    },
    {
      exact: true,
      path: 'users',
      view: lazy(() => import('src/views/AdminUsersView/index')),
      module: MODULE.USERS,
    },
    {
      exact: true,
      path: 'packages',
      view: lazy(() => import('src/views/AdminPackagesTreeView/index')),
      module: MODULE.PACKAGES,
    },
    {
      exact: true,
      path: 'roles',
      view: lazy(() => import('src/views/AdminRolesTreeView/index')),
      module: MODULE.ROLES,
    },
    {
      exact: true,
      path: 'suites',
      view: lazy(() => import('src/views/AdminAssetsTreeView/index')),
      module: MODULE.SUITES,
    },
    {
      exact: true,
      path: 'packagesOld',
      view: lazy(() => import('src/views/AdminPackagesView/index')),
      module: MODULE.PACKAGES,
    },
    {
      exact: true,
      path: 'rolesOld',
      view: lazy(() => import('src/views/AdminRolesView/index')),
      module: MODULE.ROLES,
    },
    {
      exact: true,
      path: 'rolesOld',
      view: lazy(() => import('src/views/AdminRolesView/index')),
      module: MODULE.ROLES
    },
    {
      exact: true,
      path:
        ':assignee(packages|roles)?/:assigneeId([0-9]+)?/:suite(suites)?/:suiteId([0-9]+)?/:app(apps)?/:appId([0-9]+)?/:module(modules)?/:moduleId([0-9]+)?/:function(functions)?/:functionId([0-9]+)?/:feature(features)?',
      view: lazy(() => import('src/views/AdminAssetsView/index')),
      module: MODULE.SUITES,
    },
    {
      exact: true,
      path: 'call-centers',
      view: lazy(() => import('src/views/AdminCallCentersView/index')),
      module: MODULE.CALL_CENTERS,
    },
  ],
  // Copy for all apps
  topBarConfig: {
    // dataContextOptions: PropTypes.shape({
    //   options: PropTypes.arrayOf(
    //     PropTypes.shape({
    //       key: PropTypes.any,
    //       value: PropTypes.any,
    //       name: PropTypes.string,
    //       secondLine: PropTypes.string,
    //     })
    //   ),
    //   enableDataContextOverride: PropTypes.bool,
    //   customJSX: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    // }),
    // dataContextOptions: {
    //   enableDataContextOverride: true,
    //   options: [{}],
    //   customJSX: <button>test</button>
    // },
    contacts: false,
    search: false,
    notifications: true,
    settings: true,
  },
  navConfig: {
    navBarItems: [
      {
        subheader: 'Assets',
        items: [
          {
            title: 'Companies',
            icon: GlobeIcon,
            href: 'companies',
            module: MODULE.COMPANIES,
          },
          {
            title: 'Users',
            icon: UsersIcon,
            href: 'users',
            module: MODULE.USERS,
          },
          {
            title: 'Packages',
            icon: PackageIcon,
            href: 'packages',
            module: MODULE.PACKAGES,
          },
          {
            title: 'Roles',
            icon: RolesIcon,
            href: 'roles',
            module: MODULE.ROLES,
          },
          {
            title: 'Suites',
            icon: SuitesIcon,
            href: 'suites',
            module: MODULE.SUITES,
          },
          {
            title: 'Call Centers',
            icon: CallCenterIcon,
            href: 'call-centers',
            module: MODULE.CALL_CENTERS,
          },
        ],
      },
    ],
  },
};

export default appConfig;
